// extracted by mini-css-extract-plugin
export default {"container":"style_container__DFoIP","checkbox":"style_checkbox__P8ycq","label":"style_label__Q5yDm"};